import { Typography } from "@mui/material";
import MoedaText from "../ui/inputs/moedaText";
import { map, orderBy } from "lodash";
import Ticker from "../ui/ticker";
import Patrimonio from "../../../models/analises/patrimonio";
import TabelaBase from "./tabelaBase";

type Props = {
  patrimonio: Patrimonio[] | undefined;
};

export default function TabelaPerformance({ patrimonio }: Props) {
  const header: {
    titulo: string;
    key: string;
    ordem: number;
    align: "left" | "center" | "right";
  }[] = [
    { titulo: "Ativo", key: "ativo", ordem: 1, align: "center" },
    { titulo: "Saldo Bruto", key: "saldoBruto", ordem: 2, align: "right" },
    {
      titulo: "Valor Aplicado",
      key: "valorAplicado",
      ordem: 3,
      align: "right",
    },
    { titulo: "Resultado", key: "resultado", ordem: 4, align: "right" },
  ];

  const rows = map(
    orderBy(patrimonio, (p) => p.saldoBruto - p.valorAplicado, "desc"),
    (ativo) => ({
      ativo: celulaAtivo(ativo),
      saldoBruto: celulaSaldoBruto(ativo),
      valorAplicado: celulaValorAplicado(ativo),
      resultado: celulaResultado(ativo),
    })
  );

  return <TabelaBase header={header} rows={rows} />;
  function celulaAtivo(ativo: Patrimonio): JSX.Element {
    return <Ticker codigoAtivo={ativo.codigoAtivo} />;
  }

  function celulaSaldoBruto(ativo: Patrimonio): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText displayType={"text"} value={ativo.saldoBruto}></MoedaText>
      </Typography>
    );
  }

  function celulaValorAplicado(ativo: Patrimonio): JSX.Element {
    return (
      <Typography variant="dataMono">
        <MoedaText displayType={"text"} value={ativo.valorAplicado}></MoedaText>
      </Typography>
    );
  }

  function celulaResultado(ativo: Patrimonio): JSX.Element {
    const resultado = ativo.saldoBruto - ativo.valorAplicado;
    return (
      <Typography
        variant="dataMono"
        className={resultado > 0 ? "success" : "error"}
      >
        <MoedaText displayType={"text"} value={resultado}></MoedaText>
      </Typography>
    );
  }
}
